import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  const footerSections = {
    contactUs: {
      title: t('footer.contactUs'),
      email: t('footer.email'),
      socialLinks: [
        {
          name: "Instagram",
          href: "/#",
          icon: "/assets/instagram.svg"
        },
        {
          name: "Facebook",
          href: "/#",
          icon: "/assets/facebook.svg"
        },
        {
          name: "Twitter",
          href: "/#",
          icon: "/assets/twitter.svg"
        }
      ]
    },
    forPatients: {
      title: t('footer.forPatients'),
      links: [
        { name: t('footer.findDentist'), href: "/#" },
        { name: t('footer.bookAppointment'), href: "/#" },
        { name: t('footer.howItWorks'), href: "/#" },
        { name: t('footer.pricing'), href: "/#" }
      ]
    },
    forDentists: {
      title: t('footer.forDentists'),
      links: [
        { name: t('footer.joinDentfinder'), href: "/#" },
        { name: t('footer.practiceManagement'), href: "/#" },
        { name: t('footer.appointmentSystem'), href: "/#" },
        { name: t('footer.successStories'), href: "/#" }
      ]
    },
    company: {
      title: t('footer.company'),
      links: [
        { name: t('footer.aboutUs'), href: "/#" },
        { name: t('footer.termsOfService'), href: "/#" },
        { name: t('footer.privacyPolicy'), href: "/#" },
        { name: t('footer.cookiePolicy'), href: "/#" }
      ]
    }
  };

  return (
    <footer 
      className="text-white relative overflow-hidden"
      style={{
        backgroundImage: "url('/assets/footer-bg.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // height: "100dvh",
      }}
    > 
      <div className="container-custom relative z-10">
        {/* Top Section - Links and Contact Information */}
        <div className="py-12 lg:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* CONTACT US */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">
                {footerSections.contactUs.title}
              </h4>
              <a 
                href={`mailto:${footerSections.contactUs.email}`}
                className="text-[#14C5D1] text-base mb-6 block hover:opacity-80 transition-opacity"
              >
                {footerSections.contactUs.email}
              </a>
              <div className="flex gap-3">
                {footerSections.contactUs.socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className=""
                    aria-label={social.name}
                  >
                    <img src={social.icon} alt={social.name} />
                  </a>
                ))}
              </div>
            </div>

            {/* FOR PATIENTS */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">
                {footerSections.forPatients.title}
              </h4>
              <ul className="space-y-3">
                {footerSections.forPatients.links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-white text-sm hover:text-[#14C5D1] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* FOR DENTISTS */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">
                {footerSections.forDentists.title}
              </h4>
              <ul className="space-y-3">
                {footerSections.forDentists.links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-white text-sm hover:text-[#14C5D1] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* COMPANY */}
            <div>
              <h4 className="font-bold text-white mb-4 text-base">
                {footerSections.company.title}
              </h4>
              <ul className="space-y-3">
                {footerSections.company.links.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.href}
                      className="text-white text-sm hover:text-[#14C5D1] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-dashed border-gray-600 py-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-12">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img
                src="/assets/logo.svg"
                alt="DentFinder Logo"
                className="h-8 w-auto"
              />
            </div>

            {/* Description and Copyright */}
            <div className="flex-1">
              <p className="text-white text-sm leading-relaxed mb-2">
                {t('footer.copyright')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Background Watermark Image */}
      <div className=" opacity-6">
        <img
          src="/assets/DentFinder.webp"
          alt="DentFinder Watermark"
          className="object-cover object-center"
        />
      </div>
    </footer>
  );
};

export default Footer;
